/**
 * Recharts theme, extending Plaster & Indigo: warm hairlines, no gradients,
 * the accent for the projected series, ochre for the threshold and crimson
 * for the zero line.
 *
 * Recharts takes colours as props, not classes, so these are literal hex —
 * the same values as the Tailwind tokens, not a second palette.
 */

export const CHART = {
  grid: '#E9DDD7', // rule
  axis: '#DED0CA', // rule-base
  tickFill: '#8B7A73', // ink-muted
  paper: '#FDF8F6', // surface
  ink: '#2A211E',
  accent: '#4F46A5',
  /** The low-balance threshold line — ochre, dashed. */
  warn: '#8A5A0B',
  warnFill: '#F4E7CC',
  /** Reserved for zero and for the below-zero band. Never a series colour. */
  red: '#A32036',
  redFill: '#F6DDDF',
} as const;

/** Series ramp, in order. A chart stays legible without colour alone, so
 *  distinguish further with stroke width or dash — never with hue. */
export const SERIES = ['#4F46A5', '#4E3A33', '#8B7A73', '#2A211E', '#C6B4AC'] as const;

const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const SANS = "'Instrument Sans', system-ui, sans-serif";

/** Axis ticks are metadata, so they take the mono face like every other
 *  column head and key in the system. */
export const axisTick = {
  fontFamily: MONO,
  fontSize: 11,
  fill: CHART.tickFill,
} as const;

export const axisProps = {
  axisLine: { stroke: CHART.axis },
  tickLine: false as const,
  tick: axisTick,
};

export const tooltipStyle = {
  background: CHART.paper,
  border: '1px solid #DED0CA',
  borderRadius: 4,
  boxShadow: '0 1px 2px rgba(42,33,30,.05), 0 12px 28px -12px rgba(42,33,30,.22)',
  fontFamily: SANS,
  fontSize: 13,
} as const;

export const tooltipLabelStyle = {
  fontFamily: MONO,
  fontSize: 11,
  fontWeight: 500,
  letterSpacing: '0.06em',
  textTransform: 'uppercase' as const,
  color: CHART.tickFill,
};

export const legendStyle = {
  fontFamily: SANS,
  fontSize: 12,
  color: '#5C4E49',
};
